import { gridService } from '../services'

const state = {
  events: []
}

const getters = {
  getEvents (state) {
    return state.events
  }
}

const mutations = {
  getAllEvents (state, events) {
    state.events = events.map(event => {
      return {
        ...event,
        natureLabel: event.nature.label
      }
    })
  }
}

const actions = {
  findAllEvents (context) {
    const filters = context.rootGetters['filters/getFilters']
    return gridService.findAllEvents(filters)
      .then(response => {
        context.commit('getAllEvents', response.data)
        return response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
